import React from 'react';
import { Container } from 'src/components';

export const SuspenseFallback = () => {
  return <Container backgroundColor="white" flex />;
};
